import clsx from "clsx";
import PropTypes from "prop-types";

export const SliderText = ({ onclick, isActive, title, isLight, classNames }) => {
    return (
        <button onClick={onclick} className={clsx(
            "font-semibold phone:font-normal text-[12px] text-basier-circle-semibold rounded-[4px]",
            "py-[8.5px] phone:py-[4.5px] leading-[14.87px] tablet:px-2 px-4 phone:px-2 tracking-text text-center",
            isActive && !isLight ? "bg-primary-darkhover" : "",
            isActive && !isLight ? "text-neutral-10" : "text-primary-main",
            isLight && !isActive ? "text-neutral-light" : "",
            isActive && isLight ? "bg-neutral-10 text-primary-main" : "",
            classNames
        )}>{title}</button>
    );
};

SliderText.propTypes = {
    isActive: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    isLight: PropTypes.bool.isRequired
};

export const SliderWrapper = ({ children, classNames, isLight }) => {
    return (
        <div className={clsx(
            "w-fit phone:w-full border rounded-lg p-1 phone:h-[32px]",
            isLight ? "border-[#837BFF]" : "border-primary-darkhover",
            classNames
        )}>{children}</div>
    );
};